<template>
  <v-card>
    <v-toolbar dark color="#06377a">
      <v-toolbar-title>
        Feedback & Remarks
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-btn class="mr-1" icon dark @click="closeDialog()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <div class="item">
      ITEM : <b>{{ $attrs.data.inc_name }}</b>
    </div>
    <v-card-text style="height: 350px">
      <div class="pt-5 px-2" id="divMessage">
        <v-card
          flat
          v-for="(data, index) of data"
          :color="storage_user_id == data.user_id ? '#eeeeee' : '#f8f8fc'"
          :key="index"
          class="mb-3"
        >
          <v-card-text>
            <div style="font-weight: 600">
              {{ data.name }}
              <v-btn
                depressed
                rounded
                x-small
                color="#0097a7"
                dark
                class="ml-1"
              >
                <span v-if="data.role_id === 'REQ'">Requester</span>
                <span v-if="data.role_id === 'APP1'">Approver</span>
                <span v-if="data.role_id === 'CAT'">Cataloguer</span>
                <span v-if="data.role_id === 'ADM'">Administrator</span>
                <span v-if="data.role_id === 'PROC'">Procurement</span>
              </v-btn>
            </div>
            <div class="mt-2">{{ data.message }}</div>
            <div style="font-weight: bold; font-size: 12px" align="right">
              {{ data.input_date }}
            </div>
          </v-card-text>
        </v-card>

        <v-card
          flat
          v-if="!data.length && !loading"
          color="#f8f8fc"
          class="mb-3"
        >
          <v-card-text>
            No feedback or remarks yet
          </v-card-text>
        </v-card>
      </div>
    </v-card-text>
    <v-card-actions class="footer">
      <v-text-field
        label="Feedback or Remarks"
        v-model="message"
        placeholder="Input feedback or remarks"
        append-icon="send"
        @click:append="sendFeedback()"
        v-on:keyup.enter="sendFeedback()"
      ></v-text-field>
    </v-card-actions>

    <v-snackbar
      v-model="snackbar.open"
      :timeout="snackbar.timeout ? snackbar.timeout : 6000"
      bottom
    >
      {{ snackbar.message_text }}

      <template v-slot:action="{ attrs }">
        <v-btn
          :color="snackbar.button_type ? snackbar.button_type : 'primary'"
          v-bind="attrs"
          @click="snackbar.open = false"
        >
          {{ snackbar.button_text ? snackbar.button_text : "Close" }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      name: "FeedBack",
      data: null,
      loading: false,
      message: null,
      snackbar: {
        open: false,
        message_text: null,
        button_type: "primary",
        button_text: "Close",
        timeout: 3000,
      },
      storage_user_id: atob(localStorage.getItem("user_id")),
      storage_username: atob(localStorage.getItem("username")),
      storage_fullname: atob(localStorage.getItem("fullname")),
    }
  },
  mounted() {
    this.getFeedBack()
  },
  methods: {
    getFeedBack() {
      const self = this
      const id = this.$attrs.data.id
      const url = this.base_url + "material/feedback/getdata/" + id

      this.axios.get(url).then(function(response) {
        self.data = response.data
        // const el = document.getElementById("divMessage");
        // el.scrollTop = el.scrollHeight;
      })
    },
    async sendFeedback() {
      this.loading = true
      const url = this.base_url + "material/feedback/send"
      const id = this.$attrs.data.id
      const data = {
        material_id: id,
        user_id: this.storage_user_id,
        message: this.message,
      }

      if (!this.message) {
        return false
      }

      try {
        const response = await this.axios.post(url, data)
        if (response.status === 200) {
          this.message = null
          this.getFeedBack()
          this.snackbar = {
            open: true,
            message_text: "feedback has been sent",
            button_type: "primary",
          }
        } else {
          this.snackbar = {
            open: true,
            message_text: response.message,
            button_type: "error",
          }
        }
        this.loading = false
      } catch {
        this.loading = false
        this.snackbar = {
          open: true,
          message_text: "Failed submit material, please check again your input",
          button_type: "error",
        }
      }
    },
    closeDialog() {
      this.$emit("closeDialog")
    },
  },
}
</script>

<style>
.item {
  position: sticky;
  top: 0px;
  width: 100%;
  z-index: 10;
  background-color: #f6f6f6;
  padding: 10px 15px;
  font-size: 12px;
}

.footer {
  background-color: #ffffff;
  padding-bottom: 0px;
  box-shadow: 0 1px 6px 0 rgba(49, 53, 59, 0.12);
}
</style>
